import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=312b55db&scoped=true"
import script from "./ModalTitle.vue?vue&type=script&lang=js"
export * from "./ModalTitle.vue?vue&type=script&lang=js"
import style0 from "./ModalTitle.vue?vue&type=style&index=0&id=312b55db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b55db",
  null
  
)

export default component.exports